import React, { useEffect, useRef } from 'react';

const GoogleMap = ({ address }) => {
    const mapRef = useRef(null);
    const googleMapRef = useRef(null);

    useEffect(() => {
        const initMap = async () => {
            if (!address || !window.google) return;

            // Create the geocoder
            const geocoder = new window.google.maps.Geocoder();

            // Geocode the address
            try {
                const result = await new Promise((resolve, reject) => {
                    geocoder.geocode({ address }, (results, status) => {
                        if (status === 'OK') {
                            resolve(results[0]);
                        } else {
                            reject(new Error(`Geocoding failed: ${status}`));
                        }
                    });
                });

                // Get the coordinates
                const { lat, lng } = result.geometry.location;

                // Create the map
                const map = new window.google.maps.Map(mapRef.current, {
                    center: { lat: lat(), lng: lng() },
                    zoom: 15,
                });

                // Add a marker
                new window.google.maps.Marker({
                    position: { lat: lat(), lng: lng() },
                    map: map,
                    title: address
                });

                googleMapRef.current = map;

            } catch (error) {
                console.error('Error initializing map:', error);
            }
        };

        initMap();

        // Cleanup
        return () => {
            if (googleMapRef.current) {
                // Clean up map instance if needed
            }
        };
    }, [address]);

    return (
        <div 
            ref={mapRef} 
            style={{ 
                width: '100%', 
                height: '400px', 
                borderRadius: '8px',
                marginTop: '15px'
            }} 
        />
    );
};

export default GoogleMap;